export const SEVERITY_OPTIONS = [
  { value: 'none', label: 'Yok', color: 'bg-green-500' },
  { value: 'minor', label: 'Hafif', color: 'bg-yellow-500' },
  { value: 'moderate', label: 'Orta', color: 'bg-brand' },
  { value: 'severe', label: 'Ciddi', color: 'bg-red-500' },
];

export const CONDITION_OPTIONS = [
  { value: 'good', label: 'İyi' },
  { value: 'fair', label: 'Orta' },
  { value: 'poor', label: 'Kötü' },
];

export const WARNING_LIGHTS = [
  'Motor Arıza', 'ABS', 'Hava Yastığı', 'Lastik Basıncı', 'Yağ', 'Akü',
  'Fren', 'Direksiyon', 'Motor Sıcaklığı', 'Yakıt', 'Klima', 'Diğer'
];

export const DAMAGE_LOCATIONS = [
  'Ön Tampon', 'Arka Tampon', 'Sol Ön Çamurluk', 'Sağ Ön Çamurluk',
  'Sol Arka Çamurluk', 'Sağ Arka Çamurluk', 'Kaput', 'Tavan',
  'Sol Kapı (Ön)', 'Sol Kapı (Arka)', 'Sağ Kapı (Ön)', 'Sağ Kapı (Arka)',
  'Bagaj', 'Ayna (Sol)', 'Ayna (Sağ)', 'Cam (Ön)', 'Cam (Arka)', 'Diğer'
];
